import { Text, View } from 'react-native';

export default function About() {
  return (
    <View>
      <Text>About</Text>
      <Text>Test</Text>
    </View>
  );
}
